import { Component } from "vue-property-decorator"

import GroupByBase from "./groupBy.client.base"

@Component
export default class GroupByWeb extends GroupByBase {}
